// extracted by mini-css-extract-plugin
export default {"submitBtn":"Button_submitBtn__Lw1op","link":"Button_link__OYG3w","disabled":"Button_disabled__5Pg4H","outlined":"Button_outlined__vST6v"};